module.exports = __webpack_public_path__ + "static/img/bak07.8f40983.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/bak07.jpeg
// module id = 8YID
// module chunks = 1